import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { InitiationItemBgSettingsFragmentDoc, TeleprompterSettingsFragmentDoc, ShowContactSettingsFragmentDoc, ShoppableInteractionOnInitiationItemFragmentDoc, MultipleChoiceInteractionOnInitiationItemFragmentDoc } from './initiation-item-fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateInitiationItemOnStoryEditorMutationVariables = Types.Exact<{
  input: Types.UpdateInitiationItemInput;
}>;


export type UpdateInitiationItemOnStoryEditorMutation = { __typename?: 'RootMutationType', updateInitiationItem?: { __typename?: 'InitiationItemResult', initiationItem?: { __typename?: 'InitiationItem', id: string, type: Types.InitiationItemType, interactionType: Types.InteractionType, databaseId: any, title: string, headline?: string | null, order: number, collectContact: boolean, useTextFallback: boolean, textColor?: string | null, blurEffect?: number | null, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle?: number | null, useTeleprompter: boolean, teleprompterScript?: string | null, teleprompterSpeed?: number | null, teleprompterFontSize?: number | null, teleprompterFontColor?: string | null, showContact: boolean, showContactName: boolean, showContactAvatar: boolean, showContactJobTitle: boolean, showCompanySymbol: boolean, showCompanyName: boolean, interactions: Array<{ __typename: 'MultipleChoiceInteraction', id: string, type: Types.InteractionType, multipleChoiceInteractionId: string, question: { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> } } | { __typename: 'ShoppableInteraction', id: string, type: Types.InteractionType, count: number, shoppableInteractionId: string, shoppableProducts: Array<{ __typename?: 'ShoppableProduct', id: string, ctaType: Types.ShoppableProductCtaType, customCtaText?: string | null, product: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, images?: Array<{ __typename?: 'ProductImage', id: string, src?: string | null }> | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } }> }>, colors?: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const UpdateInitiationItemOnStoryEditorDocument = gql`
    mutation updateInitiationItemOnStoryEditor($input: UpdateInitiationItemInput!) {
  updateInitiationItem(input: $input) {
    initiationItem {
      id
      type
      interactionType
      databaseId
      title
      headline
      order
      collectContact
      useTextFallback
      textColor
      ...InitiationItemBgSettings
      ...TeleprompterSettings
      ...ShowContactSettings
      interactions {
        id
        type
        ... on ShoppableInteraction {
          ...ShoppableInteractionOnInitiationItem
        }
        ... on MultipleChoiceInteraction {
          ...MultipleChoiceInteractionOnInitiationItem
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    ${InitiationItemBgSettingsFragmentDoc}
${TeleprompterSettingsFragmentDoc}
${ShowContactSettingsFragmentDoc}
${ShoppableInteractionOnInitiationItemFragmentDoc}
${MultipleChoiceInteractionOnInitiationItemFragmentDoc}`;
export type UpdateInitiationItemOnStoryEditorMutationFn = Apollo.MutationFunction<UpdateInitiationItemOnStoryEditorMutation, UpdateInitiationItemOnStoryEditorMutationVariables>;

/**
 * __useUpdateInitiationItemOnStoryEditorMutation__
 *
 * To run a mutation, you first call `useUpdateInitiationItemOnStoryEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInitiationItemOnStoryEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInitiationItemOnStoryEditorMutation, { data, loading, error }] = useUpdateInitiationItemOnStoryEditorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInitiationItemOnStoryEditorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInitiationItemOnStoryEditorMutation, UpdateInitiationItemOnStoryEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInitiationItemOnStoryEditorMutation, UpdateInitiationItemOnStoryEditorMutationVariables>(UpdateInitiationItemOnStoryEditorDocument, options);
      }
export type UpdateInitiationItemOnStoryEditorMutationHookResult = ReturnType<typeof useUpdateInitiationItemOnStoryEditorMutation>;
export type UpdateInitiationItemOnStoryEditorMutationResult = Apollo.MutationResult<UpdateInitiationItemOnStoryEditorMutation>;
export type UpdateInitiationItemOnStoryEditorMutationOptions = Apollo.BaseMutationOptions<UpdateInitiationItemOnStoryEditorMutation, UpdateInitiationItemOnStoryEditorMutationVariables>;